import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export type Language = 'en' | 'ar';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private translations: Record<string, any> = {};
  public readonly currentLanguage = signal<Language>('en');
  public readonly translationsLoaded = signal<boolean>(false);

  constructor(private http: HttpClient) {
    // Load default language on init
    this.loadTranslations(this.currentLanguage());
  }

  loadTranslations(lang: Language): Observable<boolean> {
    return this.http.get<Record<string, any>>(`/assets/i18n/${lang}.json`).pipe(
      map(translations => {
        this.translations = translations;
        this.currentLanguage.set(lang);
        this.translationsLoaded.set(true);
        return true;
      }),
      catchError(error => {
        console.error(`Failed to load translations for ${lang}:`, error);
        // Fallback to English if Arabic fails
        if (lang === 'ar') {
          return this.loadTranslations('en');
        }
        return of(false);
      })
    );
  }

  translate(key: string, params?: Record<string, string | number>): string {
    const keys = key.split('.');
    let value: any = this.translations;

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }

    if (typeof value !== 'string') {
      return key;
    }

    // Replace parameters in translation string
    if (params) {
      return value.replace(/\{\{(\w+)\}\}/g, (match, paramKey) => {
        return params[paramKey]?.toString() || match;
      });
    }

    return value;
  }

  instant(key: string, params?: Record<string, string | number>): string {
    return this.translate(key, params);
  }
}


